import React from 'react'
import styled from 'styled-components'
import Query from './Query'
import Layout from '../Layout'
import Hero, { HeroTitle } from '../Hero'
import Navigation from './Navigation'
import Markdown from '../Markdown'

const Container = styled.div`
  margin: 6rem 0;
`

export default () => (
  <Query
    render={(content) => (
      <Layout>
        <Hero>
          <HeroTitle useH1>{content.title}</HeroTitle>
        </Hero>
        <Navigation />
        <Container>
          <Markdown source={content.courses_page.body_text} />
        </Container>
      </Layout>
    )}
  />
)
